<template>
  <div class="pobr" :step="current">
    <div class="pobr__stepper" ref="$stepper" :hide="!showStepper" v-if="showStepper">
      <ui-stepper
          :steps="steps"
          :current="current"
      ></ui-stepper>
    </div>

    <form
        @submit="$event.preventDefault()"
        :step="current"
        id="main-form"
        ref="form"
    >
      <transition
          :name="transitionName"
          v-on:after-enter="onFormStepEnter"
      >
        <slot ref="content"></slot>
      </transition>
    </form>
  </div>
</template>

<script>
import UIStepper from "./UIStepper.vue";

export default {
  name: "ui-form",
  components: {
    "ui-stepper": UIStepper,
  },
  props: {
    steps: {
      type: Array,
      required: false,
      validator: (value) => Array.isArray(value) && value.length >= 2,
    },
    current: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
    titlesOverwrite: {
      type: Object,
      required: false,
    },
    showStepper: {
      type: Boolean,
      required: false,
    },
  },
  data: function () {
    return {
      currentFG: undefined,
      currentFGTitle: undefined,
      transitionName: undefined
    };
  },
  methods: {
    attachFG() {
      const $children = this.$children;

      for (const c of $children) {
        if (c.$vnode.componentOptions.tag === "ui-formgroup") {
          this.removeCurrentFG();
          this.setCurrentFG(c);
        }
      }
    },
    removeCurrentFG() {
      if (this.currentFG) {
        this.currentFG.$on("fg-progress-next", undefined);
        this.currentFG.$on("fg-progress-back", undefined);
        this.currentFG.$on("fg-submit", undefined);
        this.currentFG.$on("field-value-change", undefined);
        this.currentFG = undefined;

        window.removeEventListener('keyup', this.enterPressEventHandler);
      }
    },
    setCurrentFG(fg) {
      this.currentFG = fg;
      this.currentFG.$on("fg-progress-next", this.moveNext);
      this.currentFG.$on("fg-progress-back", this.moveBack);
      this.currentFG.$on("fg-submit", this.submit);
      this.currentFG.$on("field-value-change", this.onFieldValueChanged);

      window.addEventListener('keyup', this.enterPressEventHandler);
    },
    enterPressEventHandler(event) {
      if (event.key === 'Enter') {
        if (this.currentFG) {
          this.currentFG.onEnterKeyPressed();
        }
      }
    },
    onFormStepEnter() {
      window.scrollTo(0, 0);
      this.attachFG();
    },
    onFormStepChanged() {
      if (this.current === this.steps.length) {
        this.$emit("submit");
      } else {
        this.$emit("step-changed", this.current);
      }
    },
    moveNext() {
      this.$emit("progress-next");
    },
    moveBack() {
      this.$emit("progress-back");
    },
    submit() {
      this.$emit("submit");
    },
    onFieldValueChanged($event) {
      this.$emit("field-value-change", $event);
    },
  },
  mounted: function () {
    this.attachFG();
  },
  watch: {
    current: function (newValue, previousValue) {
      if (newValue > previousValue) {
        this.transitionName = 'slide-fade-back';
      } else {
        this.transitionName = 'slide-fade-forward';
      }
    }
  }
};
</script>

<style>
</style>
